module.exports = __webpack_public_path__ + "static/media/trapezoid.86ebd3f1.svg";